"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultValue_1 = require("./defaultValue");
var dataValue_1 = require("./dataValue");
var schemaValue_1 = require("./schemaValue");
var validate_1 = require("./validate");
var compareData_1 = require("./compareData");
var clearData_1 = require("./clearData");
var setData_1 = require("./setData");
var fixAndMergeSchema_1 = require("./fixAndMergeSchema");
var JSchema = /** @class */ (function () {
    function JSchema(schema) {
        this.schema = {};
        // this.schema={};
        if (schema) {
            this.init(schema);
        }
    }
    /**
     * ładowanie schema
     * @param schema JSONSchema | string | JSONSchema[] | string[]
     */
    JSchema.prototype.init = function (schema) {
        var schemalist = [];
        if (Array.isArray(schema)) {
            for (var _i = 0, schema_1 = schema; _i < schema_1.length; _i++) {
                var schemaitem = schema_1[_i];
                if (typeof schemaitem === 'string') {
                    schemalist.push(JSON.parse(schemaitem));
                }
                else {
                    schemalist.push(schemaitem);
                }
            }
        }
        else if (typeof schema === 'string') {
            schemalist.push(JSON.parse(schema));
        }
        else {
            schemalist.push(schema);
        }
        this.schema = fixAndMergeSchema_1.default(schemalist);
    };
    /**
     * Domyślna wartośc na podstawie pól default ze schematu
     * @param schemaPath Ściezka schematu dla ktorej zwrocic domyslan wartosc, gdy pominieta zwraca dla pelnego schematu
     */
    JSchema.prototype.defaultValue = function (force, schemaPath) {
        var schema = schemaPath ? this.schemaValue(schemaPath) : this.schema;
        if (schema) {
            return defaultValue_1.default(schema, force);
        }
        return null;
    };
    /**
     * Zwraca wartosc pola danych wg sciezki
     * @param data Pelne dane
     * @param path sciezka w formacie pole.tablica[0].pole2
     */
    JSchema.prototype.dataValue = function (data, path) {
        return dataValue_1.default(this.schema, data, path);
    };
    /**
     * Zwraca czesc schematu na podstawie sciezki
     * @param path sciezka w formacie pole.tablica[0].pole2
     */
    JSchema.prototype.schemaValue = function (path) {
        return schemaValue_1.default(this.schema, path);
    };
    /**
     * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
     * @param data dane do sprawdzenia
     * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
     * @param path sciezka schamtu, gdy pusta uzywa glownej
     */
    JSchema.prototype.validate = function (data, exitOnFirstError, schema, path) {
        if (exitOnFirstError === void 0) { exitOnFirstError = true; }
        if (schema === void 0) { schema = null; }
        if (path === void 0) { path = ''; }
        var result = validate_1.default(schema || this.schema, data, exitOnFirstError, path || '');
        if (result.errors.length) {
            result.valid = false;
        }
        return result;
    };
    /**
     * Porównuje dane uzywając schematu, zwraca CompareResult zawierający wynik porównania i listę róźnic
     * @param firstItem pierwszy element do porównania
     * @param secondItem drugi element do porównania
     */
    JSchema.prototype.compareData = function (firstItem, secondItem, compareArraySize) {
        return compareData_1.default(this.schema, firstItem, secondItem);
    };
    /**
     * Czyści dane pozostawiając tylko te zgodne ze schematem, nie weryfikuje prostych typów danych
     * @param data dane do wyczyszczenia
     * @param checkDataType czy sprawdzac poprawnośc typów danych prostych
     *                      (number,integer,boolean, string), domyślnie nie
     */
    JSchema.prototype.clearData = function (data, checkDataType) {
        return clearData_1.default(data, this.schema, checkDataType);
    };
    JSchema.prototype.setData = function (data, value, path, Vue) {
        return setData_1.default(this.schema, data, value, path, 0, Vue);
    };
    return JSchema;
}());
exports.default = JSchema;
//# sourceMappingURL=JSchema.js.map